'use client'

import VIPLoyaltyRewards from 'pageContainers/VIPLoyaltyRewards'
import BuilderTextContent from 'src/components/BuilderTextContent'

export default function VIP(props: { content?: any; builderPage: string }) {
  return (
    <>
      <VIPLoyaltyRewards />
      {props.content && <BuilderTextContent content={props.content} model={props.builderPage} />}
    </>
  )
}
